<script setup lang="ts">
  import { ref } from 'vue'

  defineProps<{
    filterCount?: number
    title: string
  }>()
  const emit = defineEmits<{
    (e: 'reset'): void
    (e: 'apply'): void
  }>()

  const modal = ref<AppModal>()
  const apply = () => {
    emit('apply')
    modal.value?.close()
  }
</script>

<template>
  <div class="mb-4 flex items-center justify-end gap-2 sm:gap-4">
    <slot name="before"></slot>

    <app-button
      class="btn-low-priority btn-icon relative"
      @click="modal?.open()"
    >
      <fa-icon
        :icon="(filterCount ?? 0) > 0 ? 'i-fas-filter' : 'i-far-filter'"
        class="text-gray-500"
      />
      <span
        v-if="(filterCount ?? 0) > 0"
        class="absolute size-5 flex-center rounded-full bg-primary-600 text-2.5 text-white font-bold -right-2 -top-2"
      >
        {{ filterCount }}
      </span>
    </app-button>

    <slot name="after"></slot>

    <app-modal
      ref="modal"
      :title="title"
    >
      <app-modal-content>
        <div class="mb-8 space-y-4">
          <slot name="filter-form"></slot>
        </div>
      </app-modal-content>

      <app-modal-footer>
        <app-button
          class="btn-low-priority"
          @click="emit('reset')"
        >
          Reset
        </app-button>
        <app-button
          class="btn-primary"
          @click="apply"
        >
          Terapkan
        </app-button>
      </app-modal-footer>
    </app-modal>
  </div>
</template>
